<template>
    <div class="row bg-secondary-13">
      <div class="col-12 p-3 m-3 bg-white rounded">
        <div>
          <em class="fas fa-info-circle text-orange mr-1" />
          <span class="color-gray-7 font-14 font-weight-bold">
            Información sobre la solicitud de Remedio Provisional
          </span>
        </div>
        <div class="row ml-3 mt-2">
          <div class="col-md-2">
            <span class="data-title d-block">Estatus:</span>
            <div>
              <span class="dot" :style="`background-color: ${statusColor}`" />
              <span class="font-14 color-black">
                {{ statusName }}
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block">Número de Solicitud:</span>
            <span class="font-14 color-black">
              {{ requestNumber }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
export default {
    name: 'RequestDetail',
    components: {},
    props: {
      requestNumber: {
        type: String,
        default: '',
      },
      statusName: {
        type: String,
        default: '',
      },
      statusColor: {
        type: String,
        default: '',
      },
    },
};
</script>
<style scoped lang="scss">
  .dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
  }
</style>